// @todo VUE3 - Ultimately, remove the EventBus entirely.
//    @see https://zolldata.atlassian.net/browse/ZD-4519
//    @see https://v3.vuejs.org/guide/migration/events-api.html#overview
/* eslint-disable */
import TinyEmitter from 'tiny-emitter';

// @ts-ignore
const emitter = new TinyEmitter();

export interface EventBus {
  $on(event: string, callback: Function, ctx?: any): this;
  $once(event: string, callback: Function, ctx?: any): this;
  $emit(event: string, ...args: any[]): this;
  $off(event: string, callback?: Function): this;
}

export const eventBus: EventBus = {
  $on: emitter.on,
  $once: emitter.once,
  $off: emitter.off,
  $emit: emitter.emit,
};

declare global {
  interface Window {
    EventBus: typeof eventBus;
  }
}
window.EventBus = window.EventBus || eventBus;
